<div class="history-toolbar mt-3">
  <label class="scope-filter">
    <span class="scope-label">{{ 'Organization Level' | translate }}:</span>
    <select class="scope-select" [ngModel]="scopeEntityId" (ngModelChange)="onScopeChange($event)" [disabled]="isLoading">
      <option [ngValue]="null">{{ 'All Organization Levels' | translate }}</option>
      @for (option of scopeOptions; track trackByOptionId($index, option)) {
        <option [ngValue]="option.id">
          {{ option.name }}@if (option.isRemoved) { ({{ 'Removed' | translate }})}
        </option>
      }
    </select>
  </label>
  @if (!isLoading && totalCount !== null) {
    <span class="history-count">
      {{ 'Showing {{shown}} of {{total}} rows' | translate: { shown: rows.length, total: totalCount } }}
    </span>
  }
</div>

<div class="custom-theme-table mt-2">
  <div class="custom-scrollbar table-responsive outer-bordered-table">
    <table mat-table class="table table-striped" [dataSource]="rows">
      <tr class="mat-row" *matNoDataRow [ngClass]="{ 'loading-row': isLoading }">
        <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
          @if (isLoading) {
            <app-rings-loader class="bg-transparent"></app-rings-loader>
          } @else {
            {{ 'No data matching the filter' | translate }}
          }
        </td>
      </tr>

      <ng-container matColumnDef="change">
        <th mat-header-cell *matHeaderCellDef>{{ 'Change' | translate }}</th>
        <td mat-cell *matCellDef="let row">
          @if (row.isRemoved) {
            <span class="removed-tag">{{ 'Removed' | translate }}</span>
          }
          <span>{{ (row.isInitial ? 'Initial value' : 'Updated') | translate }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="organizationLevelName">
        <th mat-header-cell *matHeaderCellDef>{{ 'Organization Level' | translate }}</th>
        <td mat-cell *matCellDef="let row"><span>{{ row.organizationLevelName ?? '-' }}</span></td>
      </ng-container>

      <ng-container matColumnDef="shiftId">
        <th mat-header-cell *matHeaderCellDef>{{ 'Shift' | translate }}</th>
        <td mat-cell *matCellDef="let row" [class.highlight]="row.changed.shiftId">
          <span>
            @if (row.shiftId) {
              {{ row.shiftName ?? ('Unknown' | translate) }}
            } @else {
              -
            }
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="shiftLengthHours">
        <th mat-header-cell *matHeaderCellDef>{{ 'Shift Length (hrs)' | translate }}</th>
        <td mat-cell *matCellDef="let row" [class.highlight]="row.changed.shiftLengthHours"><span>{{ row.shiftLengthHours ?? '-' }}</span></td>
      </ng-container>

      <ng-container matColumnDef="avgWeeklyHours">
        <th mat-header-cell *matHeaderCellDef>{{ 'Avg Weekly Hours' | translate }}</th>
        <td mat-cell *matCellDef="let row" [class.highlight]="row.changed.avgWeeklyHours"><span>{{ row.avgWeeklyHours ?? '-' }}</span></td>
      </ng-container>

      <ng-container matColumnDef="shiftType">
        <th mat-header-cell *matHeaderCellDef>{{ 'Shift Pattern' | translate }}</th>
        <td mat-cell *matCellDef="let row" [class.highlight]="row.changed.shiftType"><span>{{ row.shiftTypeLabel ?? '-' }}</span></td>
      </ng-container>

      <ng-container matColumnDef="numberOfWorkers">
        <th mat-header-cell *matHeaderCellDef>{{ 'Number of Employees' | translate }}</th>
        <td mat-cell *matCellDef="let row" [class.highlight]="row.changed.numberOfWorkers"><span>{{ row.numberOfWorkers ?? '-' }}</span></td>
      </ng-container>

      <ng-container matColumnDef="numberOfContractors">
        <th mat-header-cell *matHeaderCellDef>{{ 'Number of Contractors' | translate }}</th>
        <td mat-cell *matCellDef="let row" [class.highlight]="row.changed.numberOfContractors"><span>{{ row.numberOfContractors ?? '-' }}</span></td>
      </ng-container>

      <ng-container matColumnDef="dateUpdated">
        <th mat-header-cell *matHeaderCellDef>{{ 'Updated Date' | translate }}</th>
        <td mat-cell *matCellDef="let row"><span>{{ row.dateUpdatedDisplay }}</span></td>
      </ng-container>

      <ng-container matColumnDef="updatedByUserName">
        <th mat-header-cell *matHeaderCellDef>{{ 'Updated By' | translate }}</th>
        <td mat-cell *matCellDef="let row"><span>{{ row.updatedByUserName || '-' }}</span></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.removed-history-row]="row.isRemoved"></tr>
    </table>
  </div>
</div>
